import React, { useEffect, useRef } from 'react';
import Footer from "./Footer";
import "../styles/index.css";
import "../styles/Game.css";

const Game = () => {
  const iframeRef = useRef(null);

  // Handle any potential errors with iframe loading
  useEffect(() => {
    const handleIframeError = () => {
      console.error("Failed to load game iframe");
    };

    const iframe = iframeRef.current;
    if (iframe) {
      iframe.addEventListener('error', handleIframeError);
      return () => {
        iframe.removeEventListener('error', handleIframeError);
      };
    }
  }, []);

  return (
    <div className="game-page">
      <main className="game-container">
        <iframe 
          ref={iframeRef}
          src="https://dracklefy.site/game/"
          title="Game"
          className="game-frame"
          allow="autoplay"
          frameBorder="0"
        />
      </main>
      <Footer />
    </div>
  );
};

export default Game;
